/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-01 14:13:16
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-10 12:04:09
 * @FilePath: /portal2/unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/Dimensions/SimpleProductDimensionsSection.tsx
 */
import React from 'react';
import Dimensions from '../../Components/Dimensions/Dimensions';
import { useSelector } from 'react-redux';
import { setDimensions } from '../Slice';
import { reducer } from '../../tools/dataDict';
import { EnumProductType } from 'src/types/common/product';
const DimensionsSection = (props) => {
  const dimensions = useSelector(
    (state: any) => state.simpleProduct.dimensions,
  );

  // const dimensionsOnChange = (setting) => {
  //   dispatch(setDimensions(setting));
  // };
  return (
    <Dimensions
      disabled={props.disabled}
      data={dimensions}
      reducer={reducer[EnumProductType.Simple]}
      setDimensions={setDimensions}
      measurementUnits={[]}
      //dimensionsOnChange={dimensionsOnChange}
    />
  );
};
export default DimensionsSection;
